import { PosAbsolute, PosRelative } from '@layout/BuildingBlocks'
import React from 'react'

export const HighstreetReportIcon = ({
  size = 32,
  width,
  iconColor = '#4C4D4C',
  backgroundColor = '#7DD8F7',
  strokeWidth,
  shadow = true,
}) => {
  return (
    <PosRelative width={width || size} height="100%">
      <PosAbsolute>
        <svg
          width={width || size}
          height="100%"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12.5" cy="14.5" r="12.5" fill={backgroundColor} />
        </svg>
      </PosAbsolute>
      <PosAbsolute>
        <svg
          width={width || size}
          height="100%"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ filter: shadow && 'drop-shadow(0 5px 3px #bfbfbf)' }}
        >
          <path
            d="M26.5 7.00133H24.899C24.6688 5.87184 24.0553 4.8566 23.1626 4.12744C22.2698 3.39829 21.1525 3 19.9998 3C18.847 3 17.7297 3.39829 16.8369 4.12744C15.9442 4.8566 15.3307 5.87184 15.1005 7.00133H6.5C6.10218 7.00133 5.72064 7.15936 5.43934 7.44067C5.15804 7.72197 5 8.1035 5 8.50133V24.5013C5 24.8992 5.15804 25.2807 5.43934 25.562C5.72064 25.8433 6.10218 26.0013 6.5 26.0013H26.5C26.8978 26.0013 27.2794 25.8433 27.5607 25.562C27.842 25.2807 28 24.8992 28 24.5013V8.50133C28 8.1035 27.842 7.72197 27.5607 7.44067C27.2794 7.15936 26.8978 7.00133 26.5 7.00133ZM11 25.0013H6.5C6.36744 25.0012 6.24036 24.9484 6.14662 24.8547C6.05289 24.761 6.00016 24.6339 6 24.5013V20.0013H11V25.0013ZM11 19.0013H6V8.50133C6.00016 8.36877 6.05289 8.24168 6.14662 8.14795C6.24036 8.05421 6.36744 8.00148 6.5 8.00133H11V19.0013ZM20 4.00133C21.0605 4.00252 22.0772 4.42433 22.8271 5.17421C23.577 5.9241 23.9988 6.94083 24 8.00133C24 9.98963 21.2039 14.3206 20 15.71C18.7959 14.3206 16 9.98963 16 8.00133C16.0012 6.94083 16.423 5.9241 17.1729 5.17421C17.9228 4.42433 18.9395 4.00252 20 4.00133ZM27 24.5013C26.9998 24.6339 26.9471 24.761 26.8534 24.8547C26.7596 24.9484 26.6326 25.0012 26.5 25.0013H12V20.0013H27V24.5013ZM27 19.0013H12V8.00133H15C15 10.7628 19.3333 17.0013 20 17.0013C20.6667 17.0013 25 10.7628 25 8.00133H26.5C26.6326 8.00148 26.7596 8.05421 26.8534 8.14795C26.9471 8.24168 26.9998 8.36877 27 8.50133V19.0013ZM22 8.00133C22 7.60576 21.8827 7.21908 21.6629 6.89019C21.4432 6.56129 21.1308 6.30494 20.7654 6.15357C20.3999 6.00219 19.9978 5.96259 19.6098 6.03976C19.2219 6.11693 18.8655 6.30741 18.5858 6.58711C18.3061 6.86682 18.1156 7.22318 18.0384 7.61115C17.9613 7.99911 18.0009 8.40124 18.1522 8.76669C18.3036 9.13215 18.56 9.4445 18.8889 9.66427C19.2178 9.88403 19.6044 10.0013 20 10.0013C20.5304 10.0013 21.0391 9.79061 21.4142 9.41554C21.7893 9.04047 22 8.53176 22 8.00133ZM19 8.00133C19 7.80354 19.0586 7.61021 19.1685 7.44576C19.2784 7.28131 19.4346 7.15313 19.6173 7.07745C19.8 7.00176 20.0011 6.98196 20.1951 7.02054C20.3891 7.05913 20.5673 7.15437 20.7071 7.29422C20.847 7.43407 20.9422 7.61225 20.9808 7.80624C21.0194 8.00022 20.9996 8.20128 20.9239 8.38401C20.8482 8.56674 20.72 8.72291 20.5556 8.8328C20.3911 8.94268 20.1978 9.00133 20 9.00133C19.7349 9.00103 19.4807 8.89558 19.2932 8.70811C19.1057 8.52064 19.0003 8.26645 19 8.00133Z"
            fill={iconColor}
            stroke={iconColor}
            strokeWidth={strokeWidth}
          />
        </svg>
      </PosAbsolute>
    </PosRelative>
  )
}
